var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgCloseIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "e19f9871-0930-4ecb-97a4-ba40cf9c65d2",
    "data-name": "Layer 1",
    viewBox: "0 0 36.77 36.77",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .ed55ea20-e50a-4afe-a9b4-2ad3b913edb5 {\n        fill: #fff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "ed55ea20-e50a-4afe-a9b4-2ad3b913edb5",
    d: "M36.77,35.36l-1.41,1.41L0,1.41,1.41,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "ed55ea20-e50a-4afe-a9b4-2ad3b913edb5",
    d: "M0,35.36l1.41,1.41L36.77,1.41,35.36,0Z"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCloseIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/close_icon.fd84271a.svg";
export { ForwardRef as ReactComponent };